'use strict';

var protocol = window.location.protocol ? window.location.protocol : 'http:';
protocol = new RegExp('http').test(protocol) ? protocol : 'http:';

module.exports = protocol;